import { jsxs, jsx } from "react/jsx-runtime";
import { useSelected } from "slate-react";
import { BlockElement } from "../../../baseEditor/BlockElement.js";
const HorizontalRuleRenderer = (props) => {
  const isSelected = useSelected();
  return /* @__PURE__ */ jsxs(BlockElement, { element: props.element, attributes: props.attributes, withBoundaries: true, children: [
    /* @__PURE__ */ jsx("span", { contentEditable: false, children: /* @__PURE__ */ jsx(
      "hr",
      {
        style: {
          boxShadow: isSelected ? "0 0 0 0.2em rgba(0, 148, 255, 0.3)" : "none",
          backgroundColor: isSelected ? "black" : void 0
        }
      }
    ) }),
    props.children
  ] });
};
HorizontalRuleRenderer.displayName = "HorizontalRuleRenderer";
export {
  HorizontalRuleRenderer
};
//# sourceMappingURL=HorizontalRuleRenderer.js.map
